import { dossierAdvancedSearchItem } from '@app/pcs/models';
import { gql } from 'apollo-angular';

export const advancedSearchQuery = gql`
  query AdvancedSearchQuery ($searchCriteria: DossierSearchCriteriaInput!) {
    advancedSearch (searchCriteria: $searchCriteria) {
      ...dossierAdvancedSearchItem
    }
  }
  ${dossierAdvancedSearchItem}
`;

export const advancedSearchWithUserConfigurationQuery = gql`
  query AdvancedSearchQuery ($searchCriteria: DossierSearchCriteriaInput!, $userGridType: UserGridTypeInput) {
    advancedSearch (searchCriteria: $searchCriteria) {
      ...dossierAdvancedSearchItem
    }
    userGridConfiguration (type: $userGridType) {
      configuration
    }
  }
  ${dossierAdvancedSearchItem}
`;

export const hasBulkEditingOperationInProgressQuery = gql`
  query HasBulkEditingOperationInProgress ($dossierSearchType: DossierSearchTypeInput) {
    hasBulkEditingOperationInProgress(dossierSearchType: $dossierSearchType)
  }
`;


export const agencyInvolvementOptionsQuery = gql`
  query AgencyInvolvementOptionsQuery  {
    agencyInvolvementOptions {
      id
      description
    }
  }
`;
